export const USER_LOGIN_REQUEST_START = 'USER_LOGIN_REQUEST_START'
export const USER_LOGIN_REQUEST_SUCCESS = 'USER_LOGIN_REQUEST_SUCCESS'
export const USER_LOGIN_REQUEST_ERROR = 'USER_LOGIN_REQUEST_ERROR'
export const USER_LOGOUT = 'USER_LOGOUT'
